import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  feedSettings: [],
  tennisFeedSettings: [],
};

export const feedSettingsSlice = createSlice({
  name: 'feedSettings',
  initialState,
  reducers: {
    aGetFeedSettingsSuccess: (state, action) => {
      state.feedSettings = action.payload.feedSettings;
    },
    aGetTennisFeedSettingsSuccess: (state, action) => {
      state.tennisFeedSettings = action.payload.feedSettings;
    },
    aClearFeedSettings: (state) => {
      state.feedSettings = [];
    },
    aClearTennisFeedSettings: (state) => {
      state.tennisFeedSettings = [];
    },
  },
});

export const {
  aGetFeedSettingsSuccess,
  aGetTennisFeedSettingsSuccess,
  aClearFeedSettings,
  aClearTennisFeedSettings,
} = feedSettingsSlice.actions;

export default feedSettingsSlice.reducer;
